module.exports = __webpack_public_path__ + "static/media/retina-01-1.90f3815c.png";